import { Directive, ElementRef, Renderer2, AfterViewInit, Input } from '@angular/core';

// Diretiva para ícones MDI compostos (base + overlay)
@Directive({
  selector: '[appMdiComposed]',
})
export class MdiComposedDirective implements AfterViewInit {
  @Input() overlayBg?: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    const host: HTMLElement = this.el.nativeElement;
    const classes = Array.from(host.classList);
    const mdiClasses = classes.filter(c => c.startsWith('mdi-') && c !== 'mdi-composed');

    if (mdiClasses.length < 2) return;

    const baseClass = mdiClasses[0];
    const overlayClass = mdiClasses[1];

    // Remove classes MDI específicas do host (mas mantém 'mdi' para manter fonte/tamanho base)
    classes.forEach(c => {
      if (c.startsWith('mdi-') && c !== 'mdi-composed') {
        this.renderer.removeClass(host, c);
      }
    });

    if (!host.classList.contains('mdi-composed')) {
      this.renderer.addClass(host, 'mdi-composed');
    }

    host.innerHTML = '';

    const surface = getComputedStyle(host).getPropertyValue('--app-surface').trim();
    if (this.overlayBg && this.overlayBg !== 'var(--app-surface)' && this.overlayBg.toLowerCase() !== surface.toLowerCase()) {
      throw new Error('Fundo de ícone composto sem variante CSS SGR.');
    }
    // Host

    // Ícone base
    const base = this.renderer.createElement('i');
    this.renderer.addClass(base, 'app-composed-base');
    this.renderer.addClass(base, 'mdi');
    this.renderer.addClass(base, baseClass);

    // Círculo de fundo
    const bg = this.renderer.createElement('span');
    this.renderer.addClass(bg, 'app-composed-bg');

    // Ícone overlay
    const overlay = this.renderer.createElement('i');
    this.renderer.addClass(overlay, 'app-composed-overlay');
    this.renderer.addClass(overlay, 'mdi');
    this.renderer.addClass(overlay, overlayClass);

    // Montagem
    this.renderer.appendChild(bg, overlay);
    this.renderer.appendChild(host, base);
    this.renderer.appendChild(host, bg);
  }
}
